class ValidationError extends Error {
    constructor(message, status) {
        super(message);
        this.status = status;
        this.name = 'ValidationError';
    }
}

export default ValidationError;
